import { CircularProgress, Grid, SxProps, Theme, Typography } from "@mui/material";

interface CircularLoaderProps {
  sx?: SxProps<Theme>;
}

export default function CircularLoader({ sx }: CircularLoaderProps) {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
      size="grow"
      sx={sx}
    >
      <CircularProgress color="primary" />
      <Typography variant="body2">Loading</Typography>
    </Grid>
  );
}
